export default __webpack_public_path__ + "static/media/minion.e26dd1b2.png";